//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ABG_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/ABG_info.vue